<app-user-mountpoint
  [pageTitle]="'PPK Downloader (Basic Edition)'"
  [showDetails]="false"
  [showMap]="false"
  [showSnr]="false"
  [showAnalyzer]="false"
  [showDownloader]="true"
  [showAddDelButtons]="false"
  [showGetInfoButton]="false"
  [showPaginationNav]="false"
  [isDownloaderPage]="true"
></app-user-mountpoint>


